// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__1bOrJ","AuthForm":"Auth_AuthForm__2A-Og"};